import {ReactNode} from 'react'
import {StyledNavLink} from '@components/ui/navlink/style.ts'

interface NavLinkProps {
    size?: 'sm' | 'md' | 'lg'
    variant?: 'ghost'
    name?: string
    path: string
    end?: boolean
    icon?: ReactNode
}

export const NavLink = ({icon, name, path, end = false, variant = 'ghost'}: NavLinkProps) => (
    <StyledNavLink size={'sm'} variant={variant} to={path} end={end} reloadDocument={true}>
        {icon && icon}
        {name && name}
    </StyledNavLink>
)

NavLink.displayName = 'NavLink'
